// Backend-compatible bank "name" string values. These are persisted verbatim in
// the DB and matched by string elsewhere (backend + display logic) — do not
// change them, existing accounts already store these exact strings.
export const BANK_NAME = {
  FOREIGN: 'Foreign bank BIC / IBAN',
  REVOLUT: 'Revolut Bank',
  OTHER: 'Other Bank',
} as const;

export const REVOLUT_REFERRAL_URL =
  'https://revolut.com/referral/?referral-code=kevindtxd!JUN1-25-AR-H2&geo-redirect';

export const BRITE_CLIENT_SCRIPT_URL = 'https://websdk.britepayments.io/v1/client.js';

export const CLEARING_NUMBER_MAX_LENGTH = 5;
export const ACCOUNT_NUMBER_MAX_LENGTH = 10;
export const BBAN_MAX_LENGTH = 20;

// Brite session defaults — sourced from env so they can be adjusted without
// touching component code once the backend contract is confirmed.
export const BRITE_BRAND_NAME = (import.meta as any).env?.VITE_BRITE_BRAND_NAME || 'Invozio';
export const BRITE_DEFAULT_COUNTRY_ID = (import.meta as any).env?.VITE_BRITE_COUNTRY_ID || 'SE';
export const BRITE_CALLBACK_URL = window.location.origin || 'https://www.invozio.com';
